import { selectHomebotNetworkEnabled } from '../store/selectors/customerProfile'

import { selectCustomerIsTitleAgent } from '../store/selectors/customerProfile'

import { useSelector } from 'react-redux'

export const useCanViewHbnTeamPage = () => {
  const hasHomebotNetworkAccess = useSelector(selectHomebotNetworkEnabled)
  const isTitleAgent = useSelector(selectCustomerIsTitleAgent)

  return hasHomebotNetworkAccess && !isTitleAgent
}
